module.exports = __webpack_public_path__ + "static/img/3s-platform-img5.8e8a861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-platform-img5.png
// module id = XJFa
// module chunks = 0